


















import { SET_CONFIDENTIAL, SET_TEST_MODE } from '@/store/mutation-types';
import { ValueOrGetter, RouteMeta } from '@/store/types';
import Vue from 'vue';
import { mapGetters } from 'vuex';

type Config = {
  confidential: boolean;
  testMode: boolean;
};

export default Vue.extend({
  name: 'DataControls',
  computed: {
    ...mapGetters(['confidential', 'testMode', 'evalBoolean']),
    config() {
      const { dataControls } = this.$route.meta as RouteMeta;
      return {
        confidential: this.evalBoolean(dataControls?.confidential),
        testMode: this.evalBoolean(dataControls?.testMode),
      };
    },
    showControls() {
      // console.log({
      //   config: this.config,
      //   showControls: Object.values(this.config as Config).some(v => v),
      // });
      return Object.values(this.config as Config).some((v) => v);
    },
    showToggle() {
      return (key: keyof Config) => (this.config as Config)[key];
    },
  },
  methods: {
    toggleConfidential() {
      this.$store.commit(SET_CONFIDENTIAL, !this.confidential);
    },
    toggleTestMode() {
      this.$store.commit(SET_TEST_MODE, !this.testMode);
    },
  },
});
